module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLightIt.27923661.eot";